import classNames from 'classnames';
import {map, omit, sortBy} from 'lodash';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import Loader from '../../../../../components/Loader';
import {
  getUberEatsConfig,
  getUberEatsGame,
  updateUberEatsGame,
} from '../../../../../actions/entities/uberEats';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert2';
import './index.css';

const newGameWeek = {
  id: 0,
  startDate: '',
  endDate: '',
  matches: [],
  name: '',
  save: false,
};

class UberEatsDisplayedGamesWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gameWeeks: [],
      clubs: [],
      stadiums: [],
    };
  }

  onChangeGameWeekInfo = (value, key, id) => {
    const data = this.state.gameWeeks.slice(0);
    const findObj = data.find(i => i.id === id);
    findObj.save = false;
    findObj[key] = value;
    const newData = data.map(obj => (obj.id === id ? {...findObj} : obj));
    this.setState({
      gameWeeks: newData,
    });
  };

  onChangeMatchInfo = (value, key, matchId, gameWeekId) => {
    const data = this.state.gameWeeks.slice(0);
    const findGameWeek = data.find(i => i.id === gameWeekId);
    findGameWeek.save = false;
    const findMatch = findGameWeek.matches.find(i => i.id === matchId);
    findMatch[key] = value;
    findGameWeek.matches.map(obj =>
      obj.id === matchId ? {...findMatch} : obj,
    );
    const newData = data.map(obj =>
      obj.id === gameWeekId ? {...findGameWeek} : obj,
    );
    this.setState({
      gameWeeks: newData,
    });
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getUberEatsGame(), null, this.onError);
    dispatch(getUberEatsConfig(), null, this.onError);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.game !== this.props.game) {
      const data = this.props.game.data?.gameWeeks?.slice(0);
      const sortGameWeek = sortBy(data, week => {
        const day = parseInt(week?.name?.match(/\d+/)[0], 10);
        return day;
      });
      const sortTable = map(sortGameWeek, week => {
        const matches = sortBy(week.matches, match => {
          return match.order;
        });
        return {...week, matches: matches};
      });
      const dataId = sortTable?.map((gameWeek, gameWeekIndex) => {
        gameWeek.id = gameWeekIndex + 1;
        gameWeek.save = true;
        return gameWeek;
      });
      this.setState({
        gameWeeks: dataId,
      });
    }
    if (prevProps.config !== this.props.config) {
      const data = this.props?.config?.data;
      if (data) {
        const clubs = Object.values(data?.clubs || {});
        const stadiums = Object.values(data?.stadiums || {});
        this.setState({
          clubs,
          stadiums,
        });
      }
    }
  }

  updateGame() {
    const {dispatch} = this.props;
    const {gameWeeks} = this.state;
    const strippedRows = map(gameWeeks, row => {
      const save = omit(row, ['save']);
      return omit(save, ['id']);
    });
    const updateGameWeeks = strippedRows.map(i => {
      return {
        ...i,
        matches: i.matches.map(i => {
          const omitCustomMatchId =
            typeof i.id !== 'number' ? i : omit(i, ['id']);
          const omitChampionshipClubId = omit(omitCustomMatchId, [
            'home.championshipClubId',
          ]);
          return omit(omitChampionshipClubId, ['away.championshipClubId']);
        }),
      };
    });
    const data = {
      id: this.props.game.data.id,
      type: this.props.game.data.type,
      gameWeeks: updateGameWeeks,
    };
    const onSuccess = () => {
      const savedGameWeeks = this.state.gameWeeks.map(i => {
        i.save = true;
        return i;
      });
      this.setState({gameWeeks: savedGameWeeks});
      swal({
        title: 'Updated !',
        type: 'success',
      });
    };
    dispatch(updateUberEatsGame(data, onSuccess(), this.onError));
  }

  addMatch(gameWeekId) {
    const {clubs, stadiums} = this.state;
    const club = clubs[0];
    const stadium = stadiums[0];

    const data = this.state.gameWeeks.slice(0);
    const findGameWeek = data.find(i => i.id === gameWeekId);
    const endDate = findGameWeek.endDate;
    findGameWeek.save = false;
    const lastMatch = findGameWeek.matches.slice(-1)[0] || null;
    const id = lastMatch?.id + 1 || 0;
    const order = parseInt(lastMatch?.order, 10) + 1 || 1;

    const newMatch = {
      away: club,
      date: '',
      hidden: false,
      home: club,
      id: '',
      location: stadium,
      order: 0,
    };

    newMatch.id = id;
    newMatch.date = endDate;
    newMatch.order = order;
    data.find(i => i.id === gameWeekId).matches.push({...newMatch});
    this.setState({
      gameWeeks: data,
    });
  }

  addGameWeek() {
    const data = this.state.gameWeeks.slice(0);
    const lastGameWeek = this.state.gameWeeks.slice(-1)[0] || null;
    const id = lastGameWeek?.id + 1 || 0;
    const lastGameWeekNumber = parseInt(
      lastGameWeek?.name?.match(/\d+/)[0],
      10,
    );
    const name = 'J' + (lastGameWeekNumber + 1 || 1);
    newGameWeek.id = id;
    newGameWeek.name = name;
    data.push({...newGameWeek});
    this.setState({
      gameWeeks: data,
    });
  }

  deleteMatch(gameWeekId, matchId) {
    const data = this.state.gameWeeks.slice(0);
    const findGameWeek = data.find(i => i.id === gameWeekId);
    findGameWeek.save = false;
    const findMatch = findGameWeek?.matches?.filter(i => i.id !== matchId);
    findGameWeek.matches = findMatch;
    const newData = data.map(obj =>
      obj.id === gameWeekId ? {...findGameWeek} : obj,
    );
    this.setState({
      gameWeeks: newData,
    });
  }

  updateClub(clubName, key, matchId, gameWeekId) {
    const clubs = this.state.clubs;
    const findClub = clubs.find(club => club.name === clubName);
    this.onChangeMatchInfo(findClub, key, matchId, gameWeekId);
  }

  onChangeGameWeekDate(selectedDate, currentDate, key, gameWeekId) {
    const date = new Date(selectedDate);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const setDate = moment(currentDate).set({
      hour: hours || 0,
      minute: minutes || 0,
    });
    const newDate = moment(setDate).toISOString().slice(0, -5) + 'Z';
    this.onChangeGameWeekInfo(newDate, key, gameWeekId);
  }

  renderTable() {
    const {isFetching} = this.props;
    const {gameWeeks, clubs, stadiums} = this.state;

    if (!gameWeeks && !isFetching && !clubs && !stadiums) return false;

    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th className="text-center">Journée</th>
              <th className="text-center">Date de début</th>
              <th className="text-center">Heure de début</th>
              <th className="text-center">Date de fin</th>
              <th className="text-center">Heure de fin</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {map(gameWeeks, (value, index) => {
              const startDate = moment(value.startDate).toISOString();
              const endDate = moment(value.endDate).toISOString();
              return (
                <>
                  <tr>
                    <td>
                      <div className="text-center game-week-day">
                        <input
                          className="form-control day"
                          value={value.name.toUpperCase() || ''}
                          onChange={event =>
                            this.onChangeGameWeekInfo(
                              event.target.value,
                              'name',
                              value.id,
                            )
                          }
                        />
                      </div>
                    </td>
                    <td>
                      <div className="table-column">
                        <DatePicker
                          className="inputDatePicker form-control text-center"
                          selected={(startDate && new Date(startDate)) || null}
                          onChange={date => {
                            this.onChangeGameWeekInfo(
                              moment(date).toISOString().slice(0, -5) + 'Z',
                              'startDate',
                              value.id,
                            );
                          }}
                          dateFormat={'dd/MM/yyyy'}
                          placeholderText="Select date"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="table-column">
                        <DatePicker
                          className="inputDatePicker form-control text-center"
                          selected={(startDate && new Date(startDate)) || null}
                          onChange={date => {
                            this.onChangeGameWeekDate(
                              date,
                              startDate,
                              'startDate',
                              value.id,
                            );
                          }}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="HH:mm"
                          timeCaption="Time"
                          placeholderText="Select hour"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="table-column">
                        <DatePicker
                          className="inputDatePicker form-control text-center"
                          selected={(endDate && new Date(endDate)) || null}
                          onChange={date => {
                            this.onChangeGameWeekInfo(
                              moment(date).toISOString().slice(0, -5) + 'Z',
                              'endDate',
                              value.id,
                            );
                          }}
                          dateFormat={'dd/MM/yyyy'}
                          placeholderText="Select date"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="table-column">
                        <DatePicker
                          className="inputDatePicker form-control text-center"
                          selected={(endDate && new Date(endDate)) || null}
                          onChange={date => {
                            this.onChangeGameWeekDate(
                              date,
                              endDate,
                              'endDate',
                              value.id,
                            );
                          }}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="HH:mm"
                          timeCaption="Time"
                          placeholderText="Select hour"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="fa-container">
                        {value.save ? (
                          <i
                            class="fa-2x fa fa-save"
                            style={{color: 'grey'}}></i>
                        ) : (
                          <i class="fa-2x fa fa-save"></i>
                        )}
                      </div>
                    </td>
                    <td
                      key={`${index}`}
                      className="collapse-button show-hide-button"
                      data-toggle="collapse"
                      data-target={`.${index}`}>
                      <button>{'Show/Hide matches'}</button>
                    </td>
                  </tr>
                  <tr className={`${index} collapse`}>
                    <td colspan="8">
                      <thead>
                        <th className="text-center order table-details-column">
                          Ordre
                        </th>
                        <th className="text-center table-details-header">
                          Home
                        </th>
                        <th className="text-center table-details-header">
                          Away
                        </th>
                        <th className="text-center table-details-header">
                          Stadium
                        </th>
                        <th className="text-center table-details-header">
                          Date
                        </th>
                        <th className="text-center table-details-header">
                          Heure
                        </th>
                        <th className="text-center table-details-header">
                          Afficher le match
                        </th>
                      </thead>
                      <tbody>
                        {map(value?.matches, (match, matchIndex) => {
                          const date = moment(match.date).toISOString() || '';
                          return (
                            <tr key={matchIndex}>
                              <td>
                                <div className="table-details-column">
                                  <input
                                    className="form-control order"
                                    value={match.order || ''}
                                    type="number"
                                    onChange={event =>
                                      this.onChangeMatchInfo(
                                        event.target.value,
                                        'order',
                                        match.id,
                                        value.id,
                                      )
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <select
                                    className="form-control"
                                    value={match.home.name || ''}
                                    onChange={event =>
                                      this.updateClub(
                                        event.target.value,
                                        'home',
                                        match.id,
                                        value.id,
                                      )
                                    }>
                                    {map(clubs, club => {
                                      return (
                                        <option value={club.name}>
                                          {club.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <select
                                    className="form-control"
                                    value={match.away.name || ''}
                                    onChange={event =>
                                      this.updateClub(
                                        event.target.value,
                                        'away',
                                        match.id,
                                        value.id,
                                      )
                                    }>
                                    {map(Object.values(clubs), club => {
                                      return (
                                        <option value={club.name}>
                                          {club.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <select
                                    className="form-control"
                                    value={match.location || ''}
                                    onChange={event =>
                                      this.onChangeMatchInfo(
                                        event.target.value,
                                        'location',
                                        match.id,
                                        value.id,
                                      )
                                    }>
                                    {map(Object.values(stadiums), stadium => {
                                      return (
                                        <option value={stadium}>
                                          {stadium}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <DatePicker
                                    className="form-control"
                                    selected={(date && new Date(date)) || null}
                                    onChange={date => {
                                      this.onChangeMatchInfo(
                                        moment(date)
                                          .toISOString()
                                          .slice(0, -5) + 'Z',
                                        'date',
                                        match.id,
                                        value.id,
                                      );
                                    }}
                                    dateFormat={'dd/MM/yyyy'}
                                    placeholderText="Select date"
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <DatePicker
                                    className="inputDatePicker form-control"
                                    selected={(date && new Date(date)) || null}
                                    onChange={date => {
                                      this.onChangeMatchInfo(
                                        moment(date)
                                          .toISOString()
                                          .slice(0, -5) + 'Z',
                                        'date',
                                        match.id,
                                        value.id,
                                      );
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="HH:mm"
                                    timeCaption="Time"
                                    placeholderText="Select hour"
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <i
                                    onClick={() =>
                                      this.onChangeMatchInfo(
                                        !match.hidden,
                                        'hidden',
                                        match.id,
                                        value.id,
                                      )
                                    }
                                    className={classNames('fa fa-2x', {
                                      'fa-toggle-on': match.hidden
                                        ? false
                                        : true,
                                      'fa-toggle-off': match.hidden
                                        ? true
                                        : false,
                                    })}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="table-details-column">
                                  <button
                                    onClick={() =>
                                      this.deleteMatch(value.id, match.id)
                                    }>
                                    <i class="fa fa-times"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </td>
                  </tr>
                  <tr className={`${index} collapse`}>
                    <td colspan="8">
                      <button
                        onClick={() => this.addMatch(value.id)}
                        className="add-match-button">
                        Ajouter un match
                      </button>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
        <div className="text-right publish-button-container">
          <button
            className="btn btn-success m-3 publish-button"
            onClick={() => this.updateGame()}>
            Publish
          </button>
        </div>
        <div>
          <button onClick={() => this.addGameWeek()} className="add-day-button">
            Ajouter une journée
          </button>
        </div>
      </div>
    );
  }

  render() {
    const {isFetching} = this.props;
    return (
      <div id="games">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">Displayed games</h3>
            <br />
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    game: state.app.uberEats.game,
    config: state.app.uberEats.config,
  }),
  dispatch => ({dispatch}),
)(UberEatsDisplayedGamesWidget);



// WEBPACK FOOTER //
// ./src/pages/UberEats/Game/Widgets/Games/index.js